import { Lock } from "lucide-react";

const CATALOG = {
  party: {
    title: "Party",
    desc: "Group up for shared combat XP and coordinated skilling bonuses.",
    art: "/generated/hero_landing.png",
    unlock: "Total Level 50",
  },
  guild: {
    title: "Guild",
    desc: "Form clans with shared banks, guild-level bonuses, and world-boss coordination.",
    art: "/generated/viewport_house.png",
    unlock: "Total Level 120",
  },
  leagues: {
    title: "Leagues",
    desc: "Compete in seasonal ranked ladders with unique modifiers and cosmetic rewards.",
    art: "/generated/viewport_dungeon.png",
    unlock: "Total Level 150",
  },
};

export function LockedFeaturePanel({ feature, totalLevel = 0 }) {
  const c = CATALOG[feature] || CATALOG.party;
  return (
    <div className="p-4 lg:p-6" data-testid={`locked-${feature}`}>
      <div
        className="panel overflow-hidden relative"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(12,10,9,0.5) 0%, rgba(12,10,9,0.92) 100%), url(${c.art})`,
          backgroundSize: "cover", backgroundPosition: "center",
        }}
      >
        <div className="p-10 flex flex-col items-center text-center gap-4">
          <div className="w-14 h-14 rounded-full border-2 border-stone-600 bg-stone-950/70 flex items-center justify-center">
            <Lock size={22} className="text-stone-400" />
          </div>
          <h2 className="font-display text-4xl heading-gilded">{c.title}</h2>
          <p className="text-stone-300 font-body max-w-lg">{c.desc}</p>
          <div className="mt-2 uppercase tracking-[0.3em] text-[10px] font-numeric text-amber-500">
            Unlocks at {c.unlock}
          </div>
          <div className="font-numeric text-stone-400">
            Your current: <span className="text-amber-300">{totalLevel}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
